export default __webpack_public_path__ + "static/assets/1910fd300b7ea87fc7cdc2be37439e5b.png";